import { useConsultDoctorContext } from "../../Contexts/ConsultDoctorContext";
import { ErrorRounded } from "@mui/icons-material";
import Button from "../../Components/Button";
import dayjs from "dayjs";

const BookingResultModal = () => {
  const {
    setSelectedSpecialization,
    setSearchBranchResults,
    setShowSubmissionError,
    setSubmissionErrorMsg,
    submissionErrorMsg,
    setSelectedPolicy,
    setSelectedClinic,
    setSelectedDoctor,
    setSearchBranch,
    setSelectedDate,
    setSelectedTime,
    navigate,
    setMonth,
    setNotes,
    setYear,
  } = useConsultDoctorContext();

  const handleEdit = async () => {
    setShowSubmissionError(false);
    setSubmissionErrorMsg("");
    setSelectedDate();
    await setSelectedTime();
    navigate("/consult-doctor/choose-date-time");
  };

  const handleCancel = () => {
    setMonth(dayjs().format("MM"));
    setYear(dayjs().year());
    setSelectedPolicy(null);
    setSelectedClinic([]);
    setSelectedDoctor("");
    setSearchBranch("");
    setSearchBranchResults([]);
    setSelectedDate();
    setSelectedTime();
    setSelectedSpecialization(null);
    setNotes("");
    setShowSubmissionError(false);
    setSubmissionErrorMsg("");
    navigate("/home");
  };

  return (
    <div
      style={{ top: 0, left: 0, bottom: 0, right: 0 }}
      className="min-h-screen max-w-screen flex fixed bg-black bg-opacity-20 backdrop-blur-sm z-50"
    >
      <div className="sm:w-96 w-89.5 bg-white m-auto rounded-2xl p-6">
        <div className="flex items-center justify-center">
          <ErrorRounded sx={{ fontSize: "50px", color: "red" }} />
        </div>

        <div className="text-center font-semibold mt-1">Booking Result</div>

        <div className="my-2">{submissionErrorMsg}</div>

        <div className="mt-2">
          <Button className="w-full text-white" onClick={handleEdit}>
            Edit date/time
          </Button>
        </div>

        <div className="mt-2">
          <Button className="w-full bg-white border" onClick={handleCancel}>
            Cancel and go back to home.
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BookingResultModal;
